import {connect} from 'react-redux'
import React, {Component} from 'react'
import moment from 'moment'
import request from 'superagent'
import MetronicIndex from '../layout/metronic/index'
import {Form, FormGroup} from '../component/form/form'
import {Portlet, PortletHead, PortletBody, PortletFooter, PortletAlert} from '../component/widget/portlet'
import BootstrapTable from 'react-bootstrap-table-next'
import apis from '../helper/api'
import localdata from '../helper/localdata'
import action from '../helper/action'
import do_action from '../action'
import config from '../helper/config'
import swal from 'sweetalert'
import util from '../helper/util'
import Modal from 'react-responsive-modal'

class MAgentManageCommision extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
        	<div className="row">
                <div className="col-md-12">
                    <Portlet>
                        <PortletBody>
                            <div className="m-widget3">
                                
                            </div>
                        </PortletBody>
                    </Portlet>   
                </div>
            </div>
        )
    }
}


const mapDispatchToProps = (dispatch) => ({
    update_balance: val => dispatch(do_action(action.ACTION_UPDATE_USER_BALANCE, val))
})

const mapStateToProps = (state) => ({
    session : state.Session,
    profile: state.Profile
})

export default MAgentManageCommision



// WEBPACK FOOTER //
// ./src/component/magent_manage_commision.js